import type {
  AiStoryDetailsValues,
  DataStoryStepBodyProps,
} from "../../../services/dataStories/dataStoryFlow.types";

export type AiStoryDetailsStepProps =
  DataStoryStepBodyProps<AiStoryDetailsValues>;

/**
 * Empty form — the registry's `initialValues` for this step. A factory rather
 * than a shared constant so two steps can never alias the same `audiences` or
 * `selectedSourceIds` array.
 *
 * Opens on the connectors tab because that is the tab Figma 5326:88121 draws,
 * with nothing selected: an empty selection means "don't narrow the sources",
 * which is the right default for a story the AI is about to plan.
 */
export const emptyAiStoryDetails = (): AiStoryDetailsValues => ({
  goal: "",
  audiences: [],
  audienceDraft: "",
  isAddingAudience: false,
  sourceKind: "connectors",
  selectedSourceIds: [],
  selectedModelId: "",
  isAddingSource: false,
  isModelOpen: false,
});
